import React from 'react';
import '../index.css';
import QRCodeSetup from '../components/settings/QRCodeSetup';
import SettingsCard from '../components/settings/SettingsCard';

const SettingsPage = () => {
    return (
        <div className="App">
            <div className="max-w-5xl mx-auto flex flex-col gap-8">
                <div>
                    <h2 className="mb-1">Settings</h2>
                    <p className="text-slate-500">
                        Manage your profile and keep your account secure with two-factor authentication.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-start">
                    <div className="lg:col-span-2">
                        <SettingsCard />
                    </div>
                    <div className="lg:col-span-3">
                        <QRCodeSetup />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
